import BaseCommand from "@/models/api/commands/BaseCommand";

export class CloneBookingItemCommand extends BaseCommand {
  CommandName = "CloneBookingItem";
  Command: {
    IsClone: boolean; //czy booking ma być powiązany
    // z pierwotnym i czy ma iść na łańcuszek, wartość
    // tą pobrać na podstawie wyskakującego dialogu
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, isClone: boolean) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, IsClone: isClone };
  }
}
